import { useState, useEffect } from "react";
import { Wine } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const ACCESS_CREDENTIALS = {
  email: "acesso@caseirinho.pt",
  password: "jean123"
};

const ACCESS_KEY = "caseirinho_access_granted";

const AccessGate = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);

  useEffect(() => {
    // Check if user already has access
    const hasAccess = sessionStorage.getItem(ACCESS_KEY);
    if (hasAccess === "true") {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    setLoginLoading(true);

    // Simulate a small delay for UX
    setTimeout(() => {
      if (email === ACCESS_CREDENTIALS.email && password === ACCESS_CREDENTIALS.password) {
        sessionStorage.setItem(ACCESS_KEY, "true");
        setIsAuthenticated(true);
        toast.success("Acesso concedido! Bem-vindo ao Caseirinho.");
      } else {
        toast.error("Credenciais inválidas. Tente novamente.");
      }
      setLoginLoading(false);
    }, 500);
  };

  if (isLoading) {
    return (
      <div 
        className="min-h-screen flex items-center justify-center"
        style={{ backgroundColor: '#F5EEE0' }}
      >
        <div className="animate-pulse">
          <Wine className="w-16 h-16" style={{ color: '#722F37' }} />
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return children;
  }

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4"
      style={{ 
        backgroundColor: '#FFFFFF'
      }}
    >
      <div 
        className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden"
        style={{ border: '4px solid #D4AF37' }}
      >
        {/* Header */}
        <div 
          className="py-8 px-6 text-center"
          style={{ backgroundColor: '#FFFFFF' }}
        >
          <h1 
            className="text-2xl font-bold mb-2"
            style={{ 
              fontFamily: "'Playfair Display', serif",
              color: '#722F37'
            }}
          >
            Área Restrita
          </h1>
          <p 
            className="text-sm"
            style={{ color: '#5D4037' }}
          >
            Este site está em desenvolvimento.<br />
            Insira suas credenciais para acessar.
          </p>
        </div>

        {/* Form */}
        <div className="p-6 md:p-8">
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label 
                className="block text-sm font-medium mb-1.5"
                style={{ color: '#5D4037' }}
              >
                E-mail
              </label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                className="h-12 rounded-lg"
                style={{ borderColor: '#D4C4B0' }}
                data-testid="access-email"
              />
            </div>

            <div>
              <label 
                className="block text-sm font-medium mb-1.5"
                style={{ color: '#5D4037' }}
              >
                Senha
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="h-12 rounded-lg"
                style={{ borderColor: '#D4C4B0' }}
                data-testid="access-password"
              />
            </div>

            <Button
              type="submit"
              disabled={loginLoading}
              className="w-full h-12 text-base font-semibold rounded-lg mt-2"
              style={{
                backgroundColor: '#722F37',
                color: '#F5EDE0'
              }}
              data-testid="access-submit"
            >
              {loginLoading ? "Verificando..." : "Entrar"}
            </Button>
          </form>
        </div>

        {/* Footer */}
        <div 
          className="py-4 px-6 text-center"
          style={{ backgroundColor: '#FFFFFF' }}
        >
          <div className="flex items-center justify-center gap-2">
            <Wine className="w-4 h-4" style={{ color: '#D4AF37' }} />
            <span 
              className="text-xs"
              style={{ color: '#5D4037' }}
            >
              O Caseirinho - Vinhos Artesanais
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessGate;
